import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "btn-3d bg-[var(--accent)] text-[var(--accent-ink)]",
        secondary: "btn-3d bg-[var(--bg-card)] text-[var(--text)]",
        outline: "btn-3d bg-[var(--bg-elevated)] text-[var(--text)]",
        ghost: "border border-transparent bg-transparent text-[var(--text-muted)] hover:bg-[var(--bg-hover)] hover:text-[var(--text)]",
        danger: "btn-3d bg-[var(--danger)] text-[var(--accent-ink)]",
        gold: "btn-3d bg-[var(--mark)] text-[var(--accent-ink)]",
      },
      size: {
        default: "h-10 px-4",
        sm: "h-8 px-3 text-xs",
        lg: "h-11 px-5",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export function Button({
  className,
  variant,
  size,
  ...props
}: React.ComponentProps<"button"> & VariantProps<typeof buttonVariants>) {
  return <button className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}

export { buttonVariants };
